import apiService from './apiService';

const BASE_URL = '/CareerEvents';

const careerEventsService = {
    // ============ Event Types ============
    
    async getEventTypes(includeInactive = false) {
        return apiService.get(`${BASE_URL}/types?includeInactive=${includeInactive}`);
    },

    async getEventType(id) {
        return apiService.get(`${BASE_URL}/types/${id}`);
    },

    async createEventType(data) {
        return apiService.post(`${BASE_URL}/types`, data);
    },

    async updateEventType(id, data) {
        return apiService.put(`${BASE_URL}/types/${id}`, data);
    },

    async deleteEventType(id) {
        return apiService.delete(`${BASE_URL}/types/${id}`);
    },

    // ============ Career Events ============

    async getEvents(filters = {}) {
        const params = new URLSearchParams();
        if (filters.employeeId) params.append('employeeId', filters.employeeId);
        if (filters.eventTypeId) params.append('eventTypeId', filters.eventTypeId);
        if (filters.status) params.append('status', filters.status);
        if (filters.fromDate) params.append('fromDate', filters.fromDate);
        if (filters.toDate) params.append('toDate', filters.toDate);
        
        const queryString = params.toString();
        return apiService.get(`${BASE_URL}${queryString ? '?' + queryString : ''}`);
    },

    async getEvent(id) {
        return apiService.get(`${BASE_URL}/${id}`);
    },

    async getEmployeeEvents(employeeId) {
        return apiService.get(`${BASE_URL}/employee/${employeeId}`);
    },

    async getUpcomingEvents(days = 30, limit = 10) {
        return apiService.get(`${BASE_URL}/upcoming?days=${days}&limit=${limit}`);
    },

    // CEV-S1 — the signed-in employee's own events marked "visible to employee" (no permission needed)
    async getMyEvents() {
        return apiService.get(`${BASE_URL}/my`);
    },

    async createEvent(data) {
        return apiService.post(BASE_URL, data);
    },

    async updateEvent(id, data) {
        return apiService.put(`${BASE_URL}/${id}`, data);
    },

    async deleteEvent(id) {
        return apiService.delete(`${BASE_URL}/${id}`);
    },

    // ============ Follow-ups ============

    async getEventFollowUps(eventId) {
        return apiService.get(`${BASE_URL}/${eventId}/followups`);
    },

    async createFollowUp(eventId, data) {
        return apiService.post(`${BASE_URL}/${eventId}/followup`, data);
    },

    async updateFollowUp(followUpId, data) {
        return apiService.put(`${BASE_URL}/followup/${followUpId}`, data);
    },

    async completeFollowUp(followUpId, notes = null) {
        return apiService.post(`${BASE_URL}/followup/${followUpId}/complete`, { notes });
    },

    async updateFollowUpStatus(followUpId, status, notes = null) {
        return apiService.put(`${BASE_URL}/followup/${followUpId}/status`, { status, notes });
    },

    async deleteFollowUp(followUpId) {
        return apiService.delete(`${BASE_URL}/followup/${followUpId}`);
    },

    async sendReminderNow(followUpId, recipients = null, updateTracking = false) {
        return apiService.post(`${BASE_URL}/followup/${followUpId}/send-reminder`, {
            recipients: recipients,
            updateTracking: updateTracking
        });
    },

    async getPendingFollowUps(assignedToUserId = null) {
        const params = assignedToUserId ? `?assignedToUserId=${assignedToUserId}` : '';
        return apiService.get(`${BASE_URL}/followups/pending${params}`);
    }
};

export default careerEventsService;

